import { Component, Input } from '@angular/core';
import { IPermissions } from '@models/Configuration/IPermissions';
import { Morphbox } from '@models/Sessions/Morphbox/Morphbox';
import { Row } from '@models/Sessions/Morphbox/Row';
import { Session } from '@models/Sessions/Session';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { ConfigService } from '@services/config.service';
import { EventsService } from '@services/events.service';
import { SessionMorphboxRequestService } from '@services/sessions/session.morphbox.request.service';

import { NewMorphboxElementModalComponent } from './new-element-modal/new-element-modal.component';
import { NewMorphboxRowModalComponent } from './new-row-modal/new-row-modal.component';

@Component({
  selector: 'app-morph-box',
  templateUrl: './morph-box.component.html',
  styleUrls: ['./morph-box.component.scss'],
})
export class SessionModulesMorphBoxComponent {
  @Input() session: Session;
  @Input() morphbox: Morphbox; // Todo: create Morphbox model

  permissions: IPermissions;

  constructor(
    private appConfig: ConfigService,
    private bus: BusService,
    private events: EventsService,
    private modalService: NgbModal,
    private _: SessionMorphboxRequestService,
  ) {
    this.permissions = appConfig.permissions;
  }

  deleteMorphboxRow(row: Row) {
    const confirmation = confirm('Are you sure you want to delete this Row?');
    if (confirmation) {
      this.bus.publish(
        this.events.requested.action.session.morphbox.deleteRow,
        row,
        this.morphbox,
        this.session,
      );
    }
  }

  deleteMorphboxElement(row: Row, element: Element) {
    const confirmation = confirm(
      'Are you sure you want to delete this Element?',
    );
    if (confirmation) {
      this.bus.publish(
        this.events.requested.action.session.morphbox.deleteElement,
        element,
        row,
        this.morphbox,
        this.session,
      );
    }
  }

  openNewMorphboxElementModal(row: Row) {
    const modalRef = this.modalService.open(NewMorphboxElementModalComponent, {
      size: 'lg',
      windowClass: 'big-modal',
    });
    modalRef.componentInstance.session = this.session;
    modalRef.componentInstance.morphbox = this.morphbox;
    modalRef.componentInstance.row = row;
  }

  openNewMorphboxRowModal() {
    const modalRef = this.modalService.open(NewMorphboxRowModalComponent, {
      size: 'lg',
      windowClass: 'big-modal',
    });
    modalRef.componentInstance.session = this.session;
    modalRef.componentInstance.morphbox = this.morphbox;
  }
}
